// src/pages/Convocations/components/ConvocationsStats.jsx

import React from "react";

import { STAT_CARDS } from "../data/convocation.data";

import { cx } from "../utils/convocation.utils";

export default function ConvocationsStats({
  stats,
  selectedStatus,
  onSelectStatus,
}) {
  return (
    <section
      aria-label="Statistiques des convocations"
      className="
        grid grid-cols-2
        gap-3
        lg:grid-cols-4
      "
    >
      {STAT_CARDS.map(
        (statCard) => {
          const Icon =
            statCard.Icon;

          const value =
            stats[
              statCard.countKey
            ] || 0;

          const isSelected =
            selectedStatus ===
            statCard.status;

          return (
            <button
              key={statCard.key}
              type="button"
              onClick={() =>
                onSelectStatus(
                  statCard.status,
                )
              }
              aria-pressed={
                isSelected
              }
              className={cx(
                [
                  "group relative",
                  "overflow-hidden",
                  "rounded-3xl",
                  "border p-4",
                  "text-left",
                  "shadow-sm",
                  "transition duration-300",
                  "hover:-translate-y-1",
                  "hover:shadow-xl",
                  "focus-visible:outline-none",
                  "focus-visible:ring-4",
                  "focus-visible:ring-blue-500/20",
                  "sm:p-5",
                ].join(" "),
                statCard.className,
                isSelected
                  ? [
                      "ring-2",
                      "ring-blue-600",
                      "ring-offset-2",
                      "dark:ring-blue-400",
                      "dark:ring-offset-slate-950",
                    ].join(" ")
                  : "",
              )}
            >
              <div
                aria-hidden="true"
                className="
                  pointer-events-none
                  absolute -right-8 -top-8
                  h-24 w-24
                  rounded-full
                  bg-current/5
                  blur-2xl
                  transition
                  group-hover:scale-125
                "
              />

              <div
                className="
                  relative flex items-start
                  justify-between gap-3
                "
              >
                <div>
                  <p
                    className="
                      text-[10px] font-black
                      uppercase
                      tracking-[0.13em]
                      opacity-65
                      sm:text-xs
                    "
                  >
                    {statCard.label}
                  </p>

                  <p
                    className="
                      mt-2
                      text-3xl font-black
                      tracking-tight
                      sm:text-4xl
                    "
                  >
                    {value}
                  </p>

                  <p
                    className="
                      mt-1 hidden
                      text-xs font-semibold
                      opacity-60
                      sm:block
                    "
                  >
                    {
                      statCard.description
                    }
                  </p>
                </div>

                <span
                  className={cx(
                    [
                      "flex h-11 w-11",
                      "shrink-0 items-center",
                      "justify-center",
                      "rounded-2xl",
                      "text-lg",
                      "transition",
                      "group-hover:scale-110",
                    ].join(" "),
                    statCard.iconClassName,
                  )}
                >
                  <Icon />
                </span>
              </div>
            </button>
          );
        },
      )}
    </section>
  );
}